<template>
  <span>
    <img
      v-if="!error"
      class="img"
      :src="assetSrc"
      :alt="item.title"
      @load="onImageLoad"
      @error="onImageError"
    />
    <span v-else class="img error" :data-src="item.src">
      {{ errorStatus }}
    </span>
  </span>
</template>
<script>
import itemErrors from "@/store/observable/item-errors";

export default {
  name: "AssetsImage",
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      error: null,
      errorStatus: null,
    };
  },
  computed: {
    assetSrc() {
      const querySrcString = this.item.src.split("?")[0];

      if (this.item.type === "image") return `${querySrcString}?w=120`;
      if (this.item.type === "spins") return `${querySrcString}?thumb&w=120`;
      if (this.item.type === "view") return `${querySrcString}?thumb&w=120`;
      if (this.item.type === "panorama") return `${querySrcString}?thumb&w=120`;
      if (this.item.type === "model") {
        return `https://scripts.sirv.com/sirvjs/v3/graphics/icons/3d/black/icon.3d.1.svg?thumb&w=120`;
      }
      if (this.item.type === "video") {
        if (this.item?.yThumbnail) return `${this.item.yThumbnail}`;
        if (this.item?.vThumbnail) return `${this.item.vThumbnail}`;
        return `${querySrcString}?thumbnail=60&q=60`;
      }

      return querySrcString;
    },
  },
  watch: {
    "item.src"() {
      this.error = null;
      this.errorStatus = null;
    },
  },
  methods: {
    onImageLoad() {
      this.error = null;
      this.errorStatus = null;
    },
    onImageError() {
      this.error = true;
      this.errorStatus = 404;
      itemErrors.set({
        src: this.item.src,
        status: true,
        statusCode: this.errorStatus,
        added: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.assets-item {
  span {
    display: block;
    width: 100%;
  }
  .img {
    max-width: 100%;
    width: 100%;
    height: 35px;
    object-fit: contain;
  }

  &.view {
    max-width: 120px;
    flex: 0 0 120px;

    .img {
      height: auto;
    }
  }
  &.spin {
    .img {
      object-fit: contain;
    }
  }

  .error {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: #f56c6c;
  }
}
</style>
